import { ReportDraft } from "@domain/report/report";
import { SupportApi } from "./supportApi";

export type FeatureType = "ADDITIONAL_WORKSPACES" | "ADDITIONAL_WORKSPACE_STORAGE";

export class SupportService {
	constructor(private readonly supportApi: SupportApi) {}

	async requestFeature(type: FeatureType): Promise<void> {
		await this.supportApi.requestFeature(type);
	}

	async report(report: ReportDraft): Promise<void> {
		await this.supportApi.report(report);
	}
}
